import RequirementInfoCard from 'features/requirements/components/RequirementInfoCard';
import RequirementDescriptorsCard from 'features/requirements/components/RequirementDescriptorsCard';
import React, { useState } from 'react';
import RequirementFullDTO from '../dtos/RequirementFullDTO';
import RequirementReactionsSection from './RequirementReactionsSection';
import RequirementDocumentsSection from './RequirementDocumentsSection';
import RequirementAlertsSection from './RequirementAlertsSection';

interface Props {
  detail: RequirementFullDTO;
  setDetail: React.Dispatch<React.SetStateAction<RequirementFullDTO>>;
}

const TmRequirementDetailSection = ({ detail, setDetail }: Props) => {
  // state
  const [addedDocumentsCount, setAddedDocumentsCount] = useState(0);

  // helpers
  // reakce a dokumenty volají původní TM endpointy nad zdrojovým ticketem
  const sourceRequirementId = detail.idSourceRequirement;

  // render
  if (!sourceRequirementId) {
    return null;
  }

  return (
    <>
      <RequirementAlertsSection requirement={detail} setRequirement={setDetail} />
      <RequirementInfoCard 
        requirement={detail} 
        enableDescription={!!detail.descriptionShort}
      />
      {detail.requirementDescriptor &&
        <RequirementDescriptorsCard descriptors={detail.requirementDescriptor} />
      }
      <div className="row no-gutters mx-n2">
        <div className="col-xl-6 px-2">
          <RequirementReactionsSection 
            requirementId={sourceRequirementId} 
            requirementType={detail.requirementType!} 
            addedDocumentsCount={addedDocumentsCount} 
            setAddedDocumentsCount={setAddedDocumentsCount}
          />
        </div>
        <div className="col-xl-6 px-2">
          <RequirementDocumentsSection 
            requirementId={sourceRequirementId} 
            requirementType={detail.requirementType!} 
            addedDocumentsCount={addedDocumentsCount} 
            setAddedDocumentsCount={setAddedDocumentsCount}
          />
        </div>
      </div>
    </>
  )
}

export default TmRequirementDetailSection;
